/*
 * @创建文件时间: 2019-12-14 10:22:35
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-25 21:34:14
 * @联系Qq:1360484677
 * @文件介绍: 普通干线养护
 */
export default [{
        path: 'jobPlanMasterETable',
        name: 'jobPlanMasterETable',
        meta: {
            title: '月作业计划管理',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/jobPlanMasterTable')
    }, {
        path: 'disIntEManagement',
        name: 'disIntEManagement',
        meta: {
            title: '病害综合管理',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/disIntManagement')
    }, {
        path: 'inspectionRecordETable',
        name: 'inspectionRecordETable',
        meta: {
            title: '巡查记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/inspectionRecordTable')
    }, {
        path: 'diseaseSetETable',
        name: 'diseaseSetETable',
        meta: {
            title: '病害登记',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/diseaseSetTable')
    }, {
        path: 'workERecord',
        name: 'workERecord',
        meta: {
            title: '工作记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/workRecord')
    }, {
        path: 'minorReportETable',
        name: 'minorReportETable',
        meta: {
            title: '小修通报单',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/minorReportTable')
    }, {
        path: 'safetyFacilityLayETable',
        name: 'safetyFacilityLayETable',
        meta: {
            title: '安全布设记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/safetyFacilityLayTable')
    }, {
        path: 'maintainORETable',
        name: 'maintainORETable',
        meta: {
            title: '维修记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/maintainORTable')
    }, {
        path: 'acceptanceApplyETable',
        name: 'acceptanceApplyETable',
        meta: {
            title: '验收申请',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/acceptanceApplyTable')
    },
    {
        path: 'acceptanceApplyETableNew',
        name: 'acceptanceApplyETableNew',
        meta: {
            title: '验收申请（新）',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/acceptanceApplyTableNew')
    }, {
        path: 'rectificationOrderETable',
        name: 'rectificationOrderETable',
        meta: {
            title: '整改通知',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/rectificationOrderTable')
    }, {
        path: 'maintARETable',
        name: 'maintARETable',
        meta: {
            title: '验收记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/maintARTable')
    },
    {
        path: 'maintARETableNew',
        name: 'maintARETableNew',
        meta: {
            title: '维修记录卡片',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/maintARTableNew')
    },
    {
        path: 'acceptRecordE',
        name: 'acceptRecordE',
        meta: {
            title: '养护作业验收记录',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/everyday/acceptRecord')
    },
    {
        path: 'hmqrAscore',
        name: 'hmqrAscore',
        meta: {
            title: '公路养护质量等级评定',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/hmqrAscore')
    }, {
        path: 'hmqrDidps',
        name: 'hmqrDidps',
        meta: {
            title: '病害项目扣分标准',
            auth: true
        },
        component: () =>
            import ('@/views/conserve/yunData/hmqrDidps')
    }
]